import {AutonomyLevels} from '../features/operation/AutonomyLevels.js';
import {OperationHealth} from '../features/operation/OperationHealth.js';
import {useOperationDashboard} from '../features/operation/useOperationDashboard.js';

export const OperationPage = () => {
  const state = useOperationDashboard();
  if (!state) {
    return null;
  }

  return (
    <div className="dm-ops-grid">
      <AutonomyLevels
        levels={state.dashboard.levels}
        effectiveLevel={state.operation.effectiveAutonomyLevel}
      />
      <OperationHealth health={state.dashboard.health} />
    </div>
  );
};
